import type { SelectProps } from '@mui/material';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import type { FormikProps } from 'formik';
import { roles } from '../../utils/roles.js';

type Props<ID, T> = SelectProps<string[]> & { id: ID; formik: FormikProps<T> };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function FormikRolesControl<
  ID extends string,
  T extends { [key in ID]?: string[] },
>(props: Props<ID, T>): JSX.Element {
  const { formik, ...selectProps } = props;
  const value = formik.values[props.id] as string[];
  return (
    <FormControl fullWidth>
      <InputLabel id="roles-label">Roles</InputLabel>
      <Select<string[]>
        labelId="roles-label"
        {...selectProps}
        disabled={formik.isSubmitting || props.disabled}
        input={<OutlinedInput label="Roles" />}
        MenuProps={MenuProps}
        multiple
        onChange={(event) => {
          const selected =
            typeof event.target.value === 'string'
              ? [event.target.value]
              : event.target.value.sort();
          console.log(selected);
          formik.handleChange({
            ...event,
            target: { ...event.target, id: props.id, value: selected },
          });
        }}
        renderValue={(selected) =>
          selected.map((role) => roles[role] ?? role).join(', ')
        }
        value={value}
      >
        {Object.keys(roles)
          .sort()
          .map((role) => (
            <MenuItem key={role} value={role}>
              <Checkbox checked={value.includes(role)} />
              <ListItemText primary={roles[role] ?? role} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
